import React, { useCallback, useEffect, useState, VFC } from 'react'
import { Button, Icon, notification } from 'antd'

import { maintenanceMessageService } from '../../services'
import { MaintenanceMessage } from '../../types'

const Maintenance: VFC = () => {
	const [showMaintenenceIcon, setShowMaintenenceIcon] = useState<boolean>(false)

	const openNotification = (maintenence: MaintenanceMessage) => {
		const description = (
			<>
				<p>{maintenence.messageText}</p>
				{maintenence.infoUrl && (
					<p style={{ marginBottom: 0 }}>
						For more information, please{' '}
						<a href={maintenence.infoUrl} rel='noreferrer' target='_blank'>
							click here
						</a>
						.
					</p>
				)}
			</>
		)

		notification.info({
			message: 'Upcoming Changes',
			description,
			duration: 0,
			onClose: () => window.localStorage.setItem('hasSeenMaintenanceNotification', 'true')
		})
	}

	const getMaintenence = useCallback(async () => {
		const result = await maintenanceMessageService.get()
		if (!result?.data) {
			return
		}

		setShowMaintenenceIcon(result.data.shouldShowMessage)
		const maintenenceStorage: MaintenanceMessage = JSON.parse(window.localStorage.getItem('maintenance'))
		const isThereANewMaintenenceMessageToShow = maintenenceStorage?.dateTime !== result.data.dateTime
		const hasUserSeenMaintenanceMessage = window.localStorage.getItem('hasSeenMaintenanceNotification') === 'true'

		const shouldShowMessage = (isThereANewMaintenenceMessageToShow || !hasUserSeenMaintenanceMessage) && result.data.shouldShowMessage
		if (shouldShowMessage) {
			window.localStorage.setItem('hasSeenMaintenanceNotification', 'false')
			window.localStorage.setItem('maintenance', JSON.stringify(result.data))
			openNotification(result.data)
		}
	}, [])

	useEffect(() => {
		try {
			const initMaintenence = async (): Promise<void> => {
				await getMaintenence()
			}

			initMaintenence()
		} catch (error) {
			setShowMaintenenceIcon(false)
		}
	}, [getMaintenence])

	return showMaintenenceIcon ? (
		<Button
			onClick={() => openNotification(JSON.parse(window.localStorage.getItem('maintenance')))}
			type={'link'}
			style={{ padding: '0 0 0 1rem' }}
			title='Upcoming changes'
		>
			<Icon type='question-circle' theme='filled' style={{ fontSize: '1.925rem' }} />
		</Button>
	) : null
}

export default Maintenance
